<template>
  <div class="pro_page_content" v-show="isRouterAlive">
    <div class="pro_page_header_div">
      <div class="logo">
        <img style="max-width: 100%;max-height: 100%;" src="@/assets/logo.png" />
      </div>
      <!-- <img style="max-width: 100%;max-height: 100%;" src="@/assets/logo1.png" /> -->
      <div @click="setrightbar()" v-show="isPhone" :class="{clickRightShow:RightShow}" 
      class="round_btn_div" style="justify-content: center;padding: 4px 0;font-size: .5rem;width: 100%;text-align: center;color: #DDD;font-weight: 700;padding-left:0px">
        Navigation
      </div>
      <div class="btn_list" v-show="!isPhone">
        <div class="btn_header" v-for="(i,index) in unit_type_list" :key="index">
          <template>
            <div class="round_btn_div " @click="btn_n = index">{{i.name}}</div>
          </template>
          <template>
            <ul v-show="btn_n == index">
              <li v-for="(n,index2) in i.to_type" :key="index2">
                <div
                style="background: rgb(150,132,109)"
                  class="round_btn_div "
                  @click="setanimation(n.typecls,n.imgnames);"
                >{{n.name}}</div>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>

    <div class="right-bar" v-show="RightShow && isPhone">
      <div class="btn_list">
        <div class="right-bar-btn_header" v-for="(i,index) in unit_type_list" :key="index">
          <template>
            <div class="right-bar-btn-div " @click="btn_n = index" :class="{rightclickbtn:btn_n == index}" >{{i.name}}
              <svg t="1637142576371" class="icon" viewBox="0 0 1024 1024"  width="14" height="14"><path d="M517.688889 796.444444c-45.511111 0-85.333333-17.066667-119.466667-51.2L73.955556 381.155556c-22.755556-22.755556-17.066667-56.888889 5.688888-79.644445 22.755556-22.755556 56.888889-17.066667 79.644445 5.688889l329.955555 364.088889c5.688889 5.688889 17.066667 11.377778 28.444445 11.377778s22.755556-5.688889 34.133333-17.066667l312.888889-364.088889c22.755556-22.755556 56.888889-28.444444 79.644445-5.688889 22.755556 22.755556 28.444444 56.888889 5.688888 79.644445L637.155556 739.555556c-28.444444 39.822222-68.266667 56.888889-119.466667 56.888888 5.688889 0 0 0 0 0z" p-id="2427" fill="#8a8a8a"></path></svg>
              </div>
          </template>
          <template>
            <ul v-show="btn_n == index">
              <li v-for="(n,index2) in i.to_type" :key="index2">
                <div
                  :class="{rightclickbtn:RightBtnIndex == n.name}"
                  class="right-round_btn_div "
                  @click="setanimation(n.typecls,n.imgnames,n.name);"
                >{{n.name}}</div>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
    <div v-if="loadingindex" class="loading_div">
      <div style="color:white">Loading...{{Math.round(loadingindex)}}%</div>
    </div>

    <div class="operating_button" style="bottom: 100px;flex-direction: column">

      <div class="round_btn_div " :class="{round_btn_div_clk:mouse_type==0}" @click="mouse_type=0">
        <svg t="1676448737426" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10762" width="30" height="30"><path d="M456.17 941.26l-89.72 72.31a39.886 39.886 0 0 1-25.08 8.85c-11.68 0-23.26-5.09-31.17-14.9-13.86-17.2-11.15-42.38 6.05-56.25l17.22-13.87c-77.28-14.45-147.01-38.25-201.88-69.35-39.72-22.52-71.11-48.37-93.28-76.84C13.12 758.87 0.35 724.12 0.35 687.92c0-75.7 55.95-144.5 157.65-193.99v18.99c0 14.73 3.9 29.26 11.26 42.02a83.325 83.325 0 0 0 12.56 16.57C117.11 605.45 80.35 647.4 80.35 687.92c0 38.12 32.21 77.38 90.69 110.53 48.18 27.31 110.5 48.23 180.33 60.94L332.6 829.9c-11.86-18.64-6.36-43.36 12.27-55.23 18.64-11.86 43.36-6.36 55.23 12.27l64.72 101.7c10.93 17.19 7.21 39.84-8.65 52.62z" fill="#ffffff" p-id="10763"></path><path d="M181.92 571.45c-0.03 0.02-0.07 0.04-0.1 0.06a83.325 83.325 0 0 1-12.56-16.57A84.224 84.224 0 0 1 158 512.92v-18.99c0.03-0.03 0.07-0.04 0.1-0.05v19.04c0 22.08 8.78 43.05 23.82 58.53zM776.06 133.02L575.7 17.35c-38.24-22.08-85.76-22.08-124 0L251.35 133.02c-38.24 22.08-62 63.23-62 107.38v231.36c0 2.68 0.09 5.35 0.27 8.01 1.79 27.54 12.79 53.5 30.67 73.87a123.356 123.356 0 0 0 31.06 25.5L451.7 694.81c19.12 11.04 40.56 16.56 62 16.56 21.44 0 42.88-5.52 62-16.56l200.36-115.67a123.385 123.385 0 0 0 30.05-24.37c18.15-20.17 29.44-46.01 31.57-73.5 0.25-3.15 0.37-6.32 0.37-9.51V240.4c0-44.15-23.75-85.3-61.99-107.38zM491.7 86.63a43.975 43.975 0 0 1 22-5.88c7.61 0 15.21 1.96 22 5.88l184.91 106.75-183.5 103.22c-14.85 8.35-33.16 8.09-47.76-0.7L313 189.8 491.7 86.63zM315.42 523.76l-24.07-13.9c-13.57-7.84-22-22.44-22-38.1V256.89L448.1 364.45c7.44 4.48 15.23 8.13 23.25 10.95v238.38l-155.93-90.02z m442.63-52c0 15.66-8.43 30.26-21.99 38.1l-25.15 14.52-159.56 92.12V377.04c8.6-2.64 16.97-6.22 24.98-10.72L758.05 264.1v207.66zM1023.35 687.92c0 71.64-50.91 137.96-143.34 186.74-83.17 43.9-195.56 71.41-316.46 77.47-0.68 0.04-1.36 0.05-2.03 0.05-21.17 0-38.85-16.61-39.92-38-1.1-22.06 15.89-40.84 37.95-41.95 109.5-5.48 210.04-29.75 283.12-68.32 33.27-17.56 59.98-37.92 77.22-58.88 15.57-18.92 23.46-38.14 23.46-57.11 0-40.01-35.84-81.41-99.03-115.13a0.3 0.3 0 0 1-0.11-0.06c15.81-15.57 25.09-37.1 25.09-59.81V495.7c0.03 0 0.07 0.02 0.1 0.05 99.36 49.35 153.95 117.39 153.95 192.17z" fill="#ffffff" p-id="10764"></path><path d="M158.1 512.92v-19.04c-0.03 0.01-0.07 0.02-0.1 0.05v18.99c0 14.73 3.9 29.26 11.26 42.02a83.325 83.325 0 0 0 12.56 16.57c0.03-0.02 0.07-0.04 0.1-0.06-15.04-15.48-23.82-36.45-23.82-58.53z m711.2-17.22v17.22c0 22.71-9.28 44.24-25.09 59.81a0.3 0.3 0 0 0 0.11 0.06 83.443 83.443 0 0 0 13.82-17.85 84.12 84.12 0 0 0 11.26-42.02v-17.17c-0.03-0.03-0.07-0.05-0.1-0.05z" fill="#ffffff" p-id="10765"></path></svg>
      </div>
      <div class="round_btn_div " :class="{round_btn_div_clk:mouse_type==1}" @click="mouse_type=1">
      <svg t="1676448760369" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11327" width="30" height="30"><path d="M556.297 172.715a42.407 42.407 0 0 1 42.426 42.398l0.837 267.69c-0.118 1.703 0.63 2.737 1.408 2.737 0.63 0 1.29-0.699 1.506-2.284l37.74-208.953c3.732-20.672 21.844-36.166 42.162-36.166a40.074 40.074 0 0 1 7.136 0.64c23.064 4.164 38.391 27.562 34.217 50.587l-33.656 244.529c0 2.559 0.483 4.478 1.32 4.478 0.58 0 1.328-0.935 2.175-3.218l50.144-134.063c6.27-17.65 23.034-29.403 40.793-29.403A39.798 39.798 0 0 1 797.892 374c22.08 7.875 33.626 33.41 25.78 55.47l-87.904 287.191c-0.453 1.585-0.984 3.16-1.437 4.725l-0.187 0.591v0.128a187.031 187.031 0 0 1-177.847 129.1c-53.156 0-108.42-18.752-150.472-51-45.419-27.336-190.968-183.783-190.968-183.783-22.09-22.07-18.792-55.882 3.297-77.962 11.537-11.537 25.919-17.6 40.173-17.6 13.033 0 25.967 5.05 36.51 15.592l63.138 63.157c8.603 8.594 18.132 12.699 26.922 12.699a26.952 26.952 0 0 0 20.88-9.893c7.658-9.037 4.635-36.914 2.49-54.594l-31.668-260.259c-2.825-23.26 13.781-45.724 37.003-48.549a40.497 40.497 0 0 1 4.853-0.295c21.282 0 39.749 16.98 42.387 38.597l34.926 204.425c0.905 2.54 2.342 4.036 3.602 4.036s2.353-1.496 2.58-4.922l11.88-265.741a42.417 42.417 0 0 1 42.467-42.398m0-70.875a113.36 113.36 0 0 0-104.344 69.153c-0.246 0.57-0.482 1.152-0.718 1.732a111.234 111.234 0 0 0-90.022 10.976 113.597 113.597 0 0 0-32.415 29.207 115.23 115.23 0 0 0-19.067 38.489 113.843 113.843 0 0 0-3.465 44.68l21.36 175.77a120.842 120.842 0 0 0-69.3-21.863c-33.468 0-65.549 13.614-90.286 38.332-23.212 23.202-36.993 53.363-38.863 84.952a120.92 120.92 0 0 0 34.502 92.216c5.532 5.906 39.64 42.407 79.203 82.412 74.586 75.422 105.328 99.648 122.702 110.771 53.973 40.36 123.254 63.414 190.674 63.414A257.906 257.906 0 0 0 801.14 745.1c0.247-0.709 0.483-1.417 0.7-2.136l0.117-0.374a178.56 178.56 0 0 0 1.723-5.64l87.413-285.578a113.203 113.203 0 0 0 5.729-42.86 115.585 115.585 0 0 0-35.772-77.135 111.431 111.431 0 0 0-67.45-30.19l0.148-0.985a113.676 113.676 0 0 0-1.201-43.155 115.408 115.408 0 0 0-16.872-39.523 113.774 113.774 0 0 0-30.703-30.968 111.077 111.077 0 0 0-84.981-17.06 113.203 113.203 0 0 0-103.694-67.656z" fill="#ffffff" p-id="11328"></path></svg>  
      </div>
      <div class="round_btn_div " @click="reset_Shift">
        RESET
      </div>
    </div>
    <div class="bottom_btn_div" :class="{phone:isPhone}">
      <!-- 移动按钮 -->
      <!-- <div class="round_btn_div "  @mousedown="topshift" @mouseup="stopIncrement" @mouseleave="stopIncrement">
        <span>上</span>
      </div>
      <div class="round_btn_div "  @mousedown="bottomshift" @mouseup="stopIncrement" @mouseleave="stopIncrement">
        <span>下</span>
      </div>
      <div class="round_btn_div "  @mousedown="leftshift" @mouseup="stopIncrement" @mouseleave="stopIncrement">
        <span>左</span>
      </div>
      <div class="round_btn_div "  @mousedown="rightshift" @mouseup="stopIncrement" @mouseleave="stopIncrement">
        <span>右</span>
      </div> -->

      <!-- 旋转按钮 -->
      <div class="round_btn_div " @click="startrotating()">
        <svg
          t="1598104788972"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="24205"
          width="20"
          height="20"
          style="padding: 5px;"
        >
          <path
            d="M929 849a30 30 0 0 1-30-30v-83.137a447.514 447.514 0 0 1-70.921 92.209C722.935 933.225 578.442 975.008 442 953.482a444.917 444.917 0 0 1-241.139-120.591 30 30 0 1 1 37.258-47.01l0.231-0.231A385.175 385.175 0 0 0 442 892.625v-0.006c120.855 22.123 250.206-13.519 343.656-106.975a386.646 386.646 0 0 0 70.6-96.653h-87.247a30 30 0 0 1 0-60H929a30 30 0 0 1 30 30V819a30 30 0 0 1-30 30zM512 392a120 120 0 1 1-120 120 120 120 0 0 1 120-120z m293.005-147.025a29.87 29.87 0 0 1-19.117-6.882l-0.232 0.231A386.5 386.5 0 0 0 689.478 168h-0.011c-145.646-75.182-329.021-51.747-451.117 70.35a386.615 386.615 0 0 0-70.6 96.65H255a30 30 0 0 1 0 60H95a30 30 0 0 1-30-30V205a30 30 0 0 1 60 0v83.129a447.534 447.534 0 0 1 70.923-92.206C317.981 73.866 493.048 37.2 647 85.836v-0.045a444.883 444.883 0 0 1 176.143 105.291 30 30 0 0 1-18.138 53.893z"
            fill="#FFFF"
            p-id="24206"
          />
        </svg>
        <span>ROTATE</span>
      </div>
      <div class="round_btn_div " @click="stoprotating()">
        <svg
          t="1598104863542"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="25007"
          width="20"
          height="20"
          style="padding: 5px;"
        >
          <path
            d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m3.008-92.992a416 416 0 1 0 0-832 416 416 0 0 0 0 832zM320 320h384v384H320V320z"
            p-id="25008"
            fill="#FFFF"
          />
        </svg>
        <span>STOP</span>
      </div>
    </div>


    <div class="absolute-bottom-text">
      <p v-show="n < 99 && n > 34" style="display: flex;align-items: center;"> <img style="width:1.5vw" src="@/assets/img/i.png" alt=""> <span style="margin-inline-start: 2px;">Reinforced Concrete Structure with infill</span></p>
      <p>Building Plan Approval Nos.: A1276-00658-2012-BP01</p>
      <p>Building Plan Approval Date: 18 Oct 2021</p>
      <p>Visual Representations are Artist's Impression only</p>
    </div>
    <!-- <div v-show="n < 99 && n > 34" style="position: absolute;right: 25%; top: 25%;">
        <img style="width:2vw" src="@/assets/img/i.png" alt="">
      </div> -->
    <div class="pro_page_models_div"  @click="RightShow=false">
      <div class="model-outline-border" style="position: relative;">
      <div align="justify" class="img3dmodels" :style="`top:${y}px;left:${x}px;`"
      @touchstart="phonetouchstart"
      @touchmove="phonetouchmove"
      @touchend="phonetouchend"
      @mousedown="move">
        <ul style="padding-inline-start: 0px; pointer-events: none;margin-block-start: 0em;margin-block-end: 0em;">
          <li
            style="width:100%; pointer-events: none; list-style-type: none;"
            v-show="index == n"
            v-for="(i,index) in imglist"
            :key="index"
          >
            <img style="width: 100%;  pointer-events: none;" :src="i" />
          </li>
        </ul>
        <!-- <img id="floormodels" :src="imgeurl" /> -->
        <div id="animation_div" v-if="animation_list !=[]" v-for="(i,index3) in animation_list" :key="index3">

          <div
            class="animation"
            :style="`border:0px;width: ${i.w}; height: ${i.h}; left: ${i.x}; top: ${i.y}; border-color: ${i.color};background-image: url(${require('@/assets/img/'+i.ctname+'.png')});background-size:100% 100%;background-repeat:no-repeat;`"
            @click="goPage('/unitinfo',i.type)"
          >
            <!-- <div v-if="toPoint(i.h) > 10 " class="animation_for_size_div">
                <span v-for="a in 2" :key="a">{{i.ctname}}</span>
            </div>
            <div v-else class="animation_for_size_div"><span>{{i.ctname}}</span></div> -->
          </div>
         
        </div>

      </div>
    </div>
    </div>
  </div>
</template>



<script>
import { log } from "util";
import TWEEN from "tween.js/src/Tween.js";

export default {
  data() {
    return {
      imgs: [],
      positionY_1: 0,
      btn_n: null,
      loading: 0,
      loadingindex: 0,
      unit_type_list: this.Datas.unit_type_list,
      imglist: [],
      imgeurl: require("@/assets/model/00000.png"),
      markindex: 0,
      n: 0,
      fangm: 1.9,
      rotatingtype: false,
      interval: null,
      animation_list: [],
      RightBtnIndex:'',
      RightShow:false,
      isRouterAlive:true,
      isPhone:false,
      intervalId:null,
      deviatorX:0,
      deviatorY:0,
      x:0,
      y:0,
      p_x:0,
      p_y:0,
      initial_x:0,
      initial_y:0,
      mouse_type:0, //0 旋转，1 拖拽
    };
  },

  methods: {
    reset_Shift(){
      this.x = 0
      this.y = 0
      let op = document.getElementsByClassName("img3dmodels")[0]; //获取操作元素
      this.fangm = 1.9
      op.style.transform = "scale(1.9)";
      this.deviator()
    },
    leftshift(){
      var self = this
      var left = self.x
      this.intervalId = setInterval(() => {
        
        if(left >= self.deviatorX){
          left = self.deviatorX; // > 0 ? 0 : top; 限制拖动范围
        }else{
          left+=10
        }
        self.x = left
      }, 50)
    },
    rightshift(){
      var self = this
      var right = self.x
      
      this.intervalId = setInterval(() => {
        console.log(right,self.deviatorX);
        if(right <= self.deviatorX *-1){
          right = self.deviatorX * -1; // > 0 ? 0 : top; 限制拖动范围
        }else{
          right-=10
        }
        self.x = right
      }, 50)
    },
    topshift(){
      var top = this.y
      var self = this
      this.intervalId = setInterval(() => {
        
        console.log(self.y);
        if(top > self.deviatorY){
          self.y = self.deviatorY; // > 0 ? 0 : top; 限制拖动范围 
        }else{
          top+=10
          
        }
        self.y = top
      }, 50)
    },
    bottomshift(){
      var top = this.y
      var self = this
      this.intervalId = setInterval(() => {
        if(top < self.deviatorY * -1){
          self.y = self.deviatorY * -1; // > 0 ? 0 : top; 限制拖动范围
        }else{
          top-=10
          
        }
        self.y = top
      }, 50)
    },
    stopIncrement() {
      clearInterval(this.intervalId)
      this.intervalId = null
    },
    deviator(){
      let max = document.getElementsByClassName('model-outline-border')[0];
      let min = document.getElementsByClassName('img3dmodels')[0];
      let x,y,x1,y1
      x = max.clientWidth
      y = max.clientHeight
      x1 = min.clientWidth
      y1 = min.clientHeight
      console.log(x,y,x1,y1);
      this.deviatorX = (x1*this.fangm-x)/2
      this.deviatorY = (y1*this.fangm-y)/2

      let max_w = max.offsetWidth; //获取元素宽度
      let min_w = min.offsetWidth; //获取元素宽度

      let max_h = max.offsetHeight; //获取元素高度
      let min_h = min.offsetHeight; //获取元素高度
      
      this.initial_x = (max_w - min_w) / 2;
      this.initial_y = (max_h - min_h) / 2;
      console.log(this.deviatorX,this.deviatorY,this.initial_x,this.initial_y);
    },

    setrightbar(){
      this.RightShow = !this.RightShow

    },
    reload(){
    this.isRouterAlive = false
    this.$nextTick(function(){
    this.isRouterAlive = true
    })

    },
    getwin(){
          var self = this
            function transformScreen() {
              if (window.orientation === 180 || window.orientation === 0) { 
                  // alert('竖屏状态！');
                  setTimeout(()=>{
                    self.winsize()
                  },200)
              } 
              if (window.orientation === 90 || window.orientation === -90 ){ 
                  // alert('横屏状态！');
               setTimeout(()=>{
                    self.winsize()
                  },200)
              }   
            }
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', transformScreen, false);

    },

    winsize(){
      let model = document.getElementsByClassName("img3dmodels")[0];
      let content = document.getElementsByClassName("model-outline-border")[0]
      var width= window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      var height= window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      if(width>height){
        this.length=height
      }else{
        this.length=width
      }
      model.style.width = `${this.length}px`
      model.style.height = `${this.length}px`
      content.style.width = `${this.length}px`
      content.style.height = `${this.length}px`
      console.log(width,height,`${this.length}px`,this.isPhone)
    },
    toPoint(percent) {
      var str = percent.replace("%", "");
      str = str.toString();
      return str;
    },
    animate() {
      // 动画函数
      window.requestAnimationFrame(() => this.animate());
      TWEEN.update();
    },
    cutscene(start, end,parameter) {
      // 转场动画
      console.log("转场动画 ===>>",start, end,parameter,Math.abs((start-end)*10))
      let self = this;
      var tween = new TWEEN.Tween({imgindex: start,});
      tween.to({imgindex: end,},Math.abs((start-end)*10));
      tween.onUpdate(function (obj) {
        //  console.log(this.imgindex.toFixed(0));
          self.n = this.imgindex.toFixed(0); //设定主图
          self.imgpath();
      });
      tween.onComplete(function () {
        // console.log('结束');
        self.animation_list = parameter; //设定动画列表
        console.log(self.animation_list,parameter)
      });
      tween.easing(TWEEN.Easing.Cubic.InOut);
      tween.start();
    },
    removeanimation() {
      //清空动画
      this.animation_list = [];
    },

    setanimation(parameter, imgIndex,index) {
      this.removeanimation(); // 清空动画
      this.stoprotating(); // 停止旋转
      // this.n = imgIndex; //设定主图
      this.RightBtnIndex = index
      this.cutscene(this.n,imgIndex,parameter)
      // this.animation_list = parameter; //设定动画列表
    },

    // 模型旋转
    stoprotating() {
      //停止
      clearInterval(this.interval);
      this.rotatingtype = false;
    },
    startrotating() {
      //旋转
      this.removeanimation();
      if (!this.rotatingtype) {
        this.interval = setInterval(() => {
          this.n -= 1;
          this.n < 0 ? (this.n = 200) : this.n;
          // this.n < 200 ? this.n : (this.n = 0);
          this.imgpath();
        }, 120);
        this.rotatingtype = true;
      }
    },

    formatZero(num, length) {
      // 获取动态文件名称
      //num:要处理的参数
      // length: 要返回的总长度
      return (Array(length).join(0) + num).slice(-length);
    },

    // 预加载图片
    loadimg() {
      for (let index = 0; index < this.imglist.length; index++) {
        const element = this.imglist[index];
        let img = new Image();
        img.src = element;
      }
    },
    LoadingImageList() {
      this.loading = 0;
      // this.loadingindex = 0;
      this.imgs = [];
      let model = document.getElementsByClassName("img3dmodels")[0];
      // console.log(model);
      this.imgs = model.querySelectorAll("img"); //获取模型节点下的所有图片
      // console.log(this.imgs);
      Array.from(this.imgs).forEach((item) => {
        let img = new Image();
        img.onload = () => {
          this.loading++;
          this.loadingindex = (this.loading / 201) * 100;
        };
        img.src = item.getAttribute("src");
      });
      console.log(this.floorplanlist);
    },
    // 生成图片文件列表
    getlist() {
      var filenumber = 201; //文件数量
      let m_ist = [];
      for (let index = 0; index < filenumber; index++) {
        //   const element = array[index];091-Neu atNovena_00000
        let url = require(`@/assets/model/${this.formatZero(
          index,
          5
        )}.png`);
        // console.log(url);
        this.imglist.push(url);
      }
      //   console.log(m_ist)
      // this.imglist = m_ist;
      // this.loadimg();
    },

    imgpath() {
      // 设定图片路径
      this.imgeurl = this.imglist[this.n];
    },

    rotating(left, width_w) {
      // console.log("asdasd", left, this.positionY_1);
      this.removeanimation();
      //旋转函数
      // left当前传入的位置
      // width_w 最大宽度
      console.log(left, width_w);

      if (left && width_w) {
        // console.log(left, this.positionY_1, width_w, mom);
        if (left > this.positionY_1) {
          // console.log("==========>>右转", left, this.positionY_1);
          this.n -= 1;
          this.n > 0 ? this.n : (this.n = 200);
          // console.log("减", left, this.positionY_1);
          this.imgpath();
          // console.log(this.img_url);
          this.positionY_1 = left;
        } else if (left < this.positionY_1) {
          // console.log("====>>左转", left, this.positionY_1);
          this.n += 1;
          this.n < 200 ? this.n : (this.n = 0);
          // console.log("加", left, this.positionY_1);
          this.imgpath();
          // console.log(this.img_url);
          this.positionY_1 = left;
        }
      } else {
        console.log("超出元素范围");
      }
    },

    // 鼠标手势处理
    move(e) {
      let firstTime,lastTime;
      firstTime = new Date().getTime();
      // let op = e.target; //获取目标元素
      let op = document.getElementsByClassName('img3dmodels')[0];
      let width_w = op.offsetWidth; //获取元素宽度
      //   document.onmousedown = (e) => {
      //     console.log(365);
      //   };
      let newtop = op.offsetTop;
      let newleft = op.offsetLeft;

      //算出鼠标相对元素的位置,
      // let x = e.clientX - newleft;
      // let y = e.clientY - newtop;
      // let x = e.clientX - newleft;
      // let y = e.clientY - newtop;
      let x1 = e.clientX
      let y1 = e.clientY
      document.onmousemove = (e) => {
        lastTime = new Date().getTime();
        if (lastTime - firstTime > 200) {
          if(this.mouse_type==1){
          e.stopPropagation();

          let left = (this.x+e.clientX - x1)/2;
          let top = (this.y+e.clientY - y1)/2;
          
          //绑定元素位置到positionX和positionY上面
          console.log("元素跟随鼠标移动的位置===", left, top);

            if(top > this.deviatorY){
              this.y = this.deviatorY; // > 0 ? 0 : top; 限制拖动范围 
            }else if(top < this.deviatorY * -1){
              this.y = this.deviatorY * -1; // > 0 ? 0 : top; 限制拖动范围
            }else{
              this.y = top
            }

            if(left > this.deviatorX){
              this.x = this.deviatorX; // > 0 ? 0 : top; 限制拖动范围
            }else if(left < this.deviatorX * -1){
              this.x = this.deviatorX * -1; // > 0 ? 0 : top; 限制拖动范围
            }else{
              this.x = left
            }
            console.log(this.x,this.y);
          }else{
          //算出鼠标相对元素的位置
          let left = e.clientX - op.offsetLeft;
          let top = e.clientY - op.offsetTop;
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          console.log(width_w);

          this.rotating(left, width_w);
        }
        }
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.positionY_1 = 0;
      };
      document.onmousewheel = (e) => {
        // 鼠标滚轮事件
        let op = document.getElementsByClassName("img3dmodels")[0]; //获取操作元素
        var eleW = op.offsetWidth;
        var eleH = op.offsetHeight;
        console.log("鼠标缩放操作===>>>", this.fangm);

        if (e.wheelDelta < 0) {
          // console.log("-");
          this.fangm > 1 ? (this.fangm -= 0.1) : 1;
          op.style.transform = "scale(" + this.fangm + ")";
        } else {
          // console.log("+");
          this.fangm < 7 ? (this.fangm += 0.1) : 7;
          op.style.transform = "scale(" + this.fangm + ")";
        }

        this.deviator()
      };
    },

    formatZero(num, length) {
      // 获取动态文件名称
      //num:要处理的参数
      // length: 要返回的总长度
      return (Array(length).join(0) + num).slice(-length);
    },

    getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    phonetouchmove(e) {
      let as = document.getElementsByClassName("img3dmodels")[0]; //获取操作元素
      document.touchmove = (test) => {
        console.log("dddd");
      };
      if (e.touches.length == 1) {
        if(this.mouse_type==1){
            let left = e.targetTouches[0].clientX - this.p_x;
            let top = e.targetTouches[0].clientY - this.p_y;
            // this.Drag(op, top, left); //拖动元素
            if(top > this.deviatorY){
              this.y = this.deviatorY; // > 0 ? 0 : top; 限制拖动范围 
            }else if(top < this.deviatorY * -1){
              this.y = this.deviatorY * -1; // > 0 ? 0 : top; 限制拖动范围
            }else{
              this.y = top
            }

            if(left > this.deviatorX){
              this.x = this.deviatorX; // > 0 ? 0 : top; 限制拖动范围
            }else if(left < this.deviatorX * -1){
              this.x = this.deviatorX * -1; // > 0 ? 0 : top; 限制拖动范围
            }else{
              this.x = left
            }
        }else{
          console.log("滑动---");
          let op = e.target; //获取目标元素 phone
          let width_w = op.offsetWidth; //获取元素宽度
          //算出鼠标相对元素的位置
          let left = e.targetTouches[0].pageX;
          let top = e.targetTouches[0].pageY;
          // console.log(width_w);
          this.rotating(left, width_w);
        }

      }
      if (e.touches.length == 2) {
        console.log("缩放---");
        var now = e.touches;
        var scale =
          this.getDistance(now[0], now[1]) /
          this.getDistance(this.start[0], this.start[1]);
        console.log("获得缩放比例---", scale);

        scale = scale.toFixed(2);
        console.log("比例取整---", scale);
        // scale >= 0.5 ? scale : 0.5;
        as.style.transform = "scale(" + scale + ")";
        this.fangm = scale
        this.deviator()
      }
    },
    phonetouchstart(e) {
      console.log("手指按下开始执行---");
      let op = document.getElementsByClassName('img3dmodels')[0];
      let htmls = document.querySelector("html");
      htmls.style = "overflow:hidden;height:100%;";
      if (e.touches.length == 2) {
        //判断是否有两个点在屏幕上
        console.log("双指---");
        this.start = e.touches; //得到第一组两个点
      }
      if (e.touches.length == 1) {
        // console.log("单指---");
        this.p_x = e.targetTouches[0].clientX - op.offsetLeft;
        this.p_y = e.targetTouches[0].clientY - op.offsetTop;
        console.log(this.x, this.y);

        // let x = e.targetTouches[0].pageX;
        // let y = e.targetTouches[0].pageY;
      }
    },
    phonetouchend() {
      console.log("结束操作---");
      let htmls = document.querySelector("html");
      htmls.style = "overflow: visible;";
      // this.x = 0;
      // this.y = 0;
    },
    goPage(pageName, item) {
      console.log(pageName, item);

      this.$router
        .push({
          path: pageName,
          query: {
            typename: item,
          },
        })
        .catch((err) => {});
    },
  },

  watch: {
    n(val, oldval) {
      console.log(val);
    },

    imglist() {
      // 监听楼栋图片列表
      this.$nextTick(() => {
        // this.loadingindex = false;
        // console.log(this.loadingindex);

        this.LoadingImageList(); //加载图片
      });
    },
    loadingindex(val, oldval) {
      // 终止加载动画
      if (val == 100) {
        this.loadingindex = false;
        console.log(val);
        //然后可以对后台发送一些ajax操作
      }
    },
  },

  mounted() {
    this.winsize()
    this.n = 0;
    this.getlist();
    this.animate()
    this.getwin()
    this.deviator()


    // 手机 PC处理
    var browser = {
    versions: function() {
    var u = navigator.userAgent, app = navigator.appVersion;
    console.log(u);
    return {//移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
    };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    if(browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad){
    this.isPhone = true   
    }else{
    this.isPhone = false   
    }
  },
};
</script>

<style >
@import "~@/style/css/FloorAnimation.css";

.round_btn_div_clk{
  background: #8bc34a !important;
  color: black !important;
}

.clickRightShow{
background-color: #444 !important;
color: #dccfbe !important;
}


.rightclickbtn{
  color: #d5c2ac !important;
}
.right-bar{
    position: absolute;
    right: 0px;
    z-index: 201;
    width: 30%;
    height: 100%;
    overflow: auto;
    background: rgb(0 0 0 / 56%);
}
.right-bar-btn-div{
    line-height: 30px;
    letter-spacing: 2px;
    color: #DDD;
    font-weight: 700;
    border-radius: 15px;
    align-items: center;
    display: flex;
    padding-left: 13px;
    text-align: start;
}

.right-bar-btn_header{
  padding: 4px 0;
}
.right-bar-btn_header ul{
    margin-block-start: 0px;
    margin-block-end: 0px;
    padding-inline-start: 2px;
    margin-inline-end: 10px;
}

.right-bar-btn_header ul li {
  padding: 4px;
  list-style-type: none;
}

.right-round_btn_div{
    font-weight: 700;
    line-height: 30px;
    background: rgba(0,0,0,0.3);
    color: #DDD;
    border-radius: 15px;
    /* height: 30px; */
    align-items: center;
    display: grid;
    justify-content: start;
    padding-left: 13px;
    text-align: start;
}

.absolute-bottom-text{
      color: white;
    position: absolute;
    left: 10px;
    bottom: 20px;
    font-size: 0.5vw;
    text-align: start;
    z-index: 200;
}
#animation_div{
  position: absolute;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}
.animation_for_size_div {
  color: white;
  /* font-size: x-large; */
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
}

.loading_div {
  width: 100vw;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998;
  background: rgb(139, 138, 138, 0.5);
}
#floormodels {
  pointer-events: none;
  position: absolute;
}

.pro_page_models_div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  align-items: center;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.img3dmodels {
  position: relative;
  /* left: 0; */
  /* right: 0; */
  /* margin: 0 auto; */
  /* top: 10vh; */
  justify-content: center;
  /* top: 0; */
  /* bottom: 0; */
  /* width: 80%;
  height: 80%; */
  width: 800px;
  height: 800px;
  transform: scale(1.5);
  font-size: x-small; 
  align-items: center;
  display: flex;
}

.operating_button{
  position: fixed;
  bottom: 100px;
  display: flex;
  /* left: 30px; */
  right: 30px;
  font-size: 12px;
  z-index: 200;
}
.operating_button div{
  margin: 10px 0px;
  padding: 3px;
  display: flex;
  width: 80px;
  justify-content: center;
  align-items: center;
}
.bottom_btn_div {
  position: fixed;
  bottom: 30px;
  display: flex;
  /* left: 30px; */
  right: 30px;
  font-size: 12px;
  z-index: 200;
}

.bottom_btn_div div {
  margin: 0 8px;
  padding: 3px;
  display: flex;
  width: 120px;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 185px;
  line-height: 15px;
  border-radius: 10px;
  /* padding: 20px; */
  /* background: #000; */
  height: auto;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pro_page_content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.pro_page_header_div {
  position: absolute;
  width: 185px;
  max-height: 95vh;
  left: 15px;
  top: 15px;
  z-index: 200;
  overflow: auto;
  /* font-family: Regular;  */
}
.btn_list {
  width: 100%;
  /* display: list-item; */
  font-size: 12px;
  margin-top: 10px;
}

.round_btn_div {
  line-height: 30px;
  background: #544433;
  color: white;
  border-radius: 15px;
  /* height: 30px; */
  align-items: center;
  display: grid;
  justify-content: start;
  padding-left: 13px;
  text-align: start;
}



.round_btn_div:hover{
    cursor: pointer;
      -webkit-touch-callout: none;
       -moz-user-select: none; /*火狐*/
       -webkit-user-select: none;  /*webkit浏览器*/
       -ms-user-select: none;   /*IE10*/
       -khtml-user-select: none; /*早期浏览器*/
       user-select: none;
    }

.btn_header {
  padding: 4px 0;
}
.btn_header ul li {
  padding: 4px;
  list-style-type: none;
}
.btn_header ul {
  padding-inline-start: 0px;
  margin-block-end: auto;
  /* padding-inline-start: 0px; */
  margin-block-start: 0px;
  margin: 2px 0;
}

.pro_page_content {
  /* 背景 */
  /* background-color: #fff79e; */
  background-image: url("~@/assets/img/background.png");
  background-attachment: fixed;
  background-size: cover;
  background-color: white !important;
}
/* 
  .leftclass{
    display: block;
  }
  .rightclass{
    display: none;
  }

@media screen and (max-height: 800px) and (max-width: 1020px) {
  .pro_page_header_div{
    width:auto;
  }
  .leftclass{
    display: none;
  }
  .rightclass{
    display: block;
  }
} */


@media screen and (max-width: 800px) {

  .animation_for_size_div span{
    /* transform: scale(0.5); */
  }
  .img3dmodels {
    position: absolute;
    bottom: 25px;
  }
   .logo{
    width: 85px;

  }
  .pro_page_header_div{
    width: 125px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .round_btn_div{
        line-height: 16px !important;

  } 
    .btn_header ul{
  padding-inline-start: 20px;

  }
}

.phone{
  right: 30% !important;
}
.phone div{
  padding:0px !important;
}
@media screen and (max-height: 800px) {
  /* .img3dmodels {
    width: 400px;
    height: 400px;
  } */
    .logo{
    width: 85px;
  }
  .pro_page_header_div{
    display: flex;
    flex-flow: column;
    align-items: center;
  }

}
</style>
